import React from 'react'
import store from 'store'
import { Provider } from 'react-redux'
import { initCompanyList } from 'actions/projects/form_actions'
import Selector from './selector'

class CompanySelectorApp extends React.Component {

  constructor (props) {
    super(props)
    store.dispatch(initCompanyList({ ...props }))
  }

  render () {
    return (
      <Provider store={store}>
        <Selector />
      </Provider>
    )
  }
}

export default CompanySelectorApp
